import React from 'react';
import PendingPayablesContainer from '../../components/modules/Reports/PendingPayables/PendingPayablesContainer';

const PendingPayables = () => {
  return <PendingPayablesContainer />;
};

export default PendingPayables;
